// Switch.js
import React, { useContext } from "react";
import { ThemeContext } from "../logic/themeContext";
import "../style/switch.css";

function Switch({ close, popup, switchBtn, position }) {
  const { changeTheme } = useContext(ThemeContext);

  return (
    <div
      className={`btnContainer ${
        popup ? "btnContainerVisible" : "btnContainerNotVisible"
      }`}
    >
      <div className="squareContainerFixed">
        <div className="squareMove" style={{ top: `${position}px` }}></div>
        <div
          onClick={() => {
            switchBtn(0);
            changeTheme("day");
          }}
          className="btnSwitch"
        >
          <img src="/media/icons/sunSvg.svg" className="imgSun" alt="sun" />
        </div>
        <div
          onClick={() => {
            switchBtn(50);
            changeTheme("auto");
          }}
          className="btnSwitch"
        >
          <p className="colorAuto">Auto</p>
        </div>
        <div
          onClick={() => {
            switchBtn(100);
            changeTheme("dark");
          }}
          className="btnSwitch"
        >
          <img src="/media/icons/night.png" className="imgSun" alt="night" />
        </div>
      </div>
      <img
        src="/media/icons/close.png"
        className="btnClose"
        onClick={close}
        alt="button close"
      />
    </div>
  );
}

export default Switch;
